import {useTranslation} from 'react-i18next';
import {Slider} from './ui/slider';
import {currency} from '../lib/api';
import {CHEQUE_SIZES} from '../lib/chequeSizes';

export const ChequeSizeSlider = ({selectedIndex, onChange}) => {
  const {t, i18n} = useTranslation();
  const copy = key => t(`preSeed.${key}`);
  const selected = CHEQUE_SIZES[selectedIndex];
  const locale = i18n.language === 'hi' ? 'hi-IN' : 'en-IN';
  const labelFor = size => `₹${size.display} ${copy(`${size.unit}Unit`)}`;
  const selectedLabel = labelFor(selected);
  const fullAmount = currency(selected.amount, locale);

  function changeStop(values) {
    const next = values[0];
    if (Number.isInteger(next) && next >= 0 && next < CHEQUE_SIZES.length) onChange(next);
  }

  return <div className="preseed-cheque-control" data-testid="preseed-cheque-control">
    <div className="preseed-amount-label" data-testid="preseed-amount-label">
      <span id="preseed-cheque-label">{copy('amountLabel')}</span><span>INR</span>
    </div>
    <div className="preseed-cheque-readout">
      <output id="preseed-cheque-value" data-testid="preseed-cheque-value">{selectedLabel}</output>
      <span data-testid="preseed-cheque-amount">{fullAmount}</span>
    </div>
    <Slider className="preseed-cheque-slider" data-testid="preseed-cheque-slider"
      min={0} max={CHEQUE_SIZES.length - 1} step={1} value={[selectedIndex]}
      onValueChange={changeStop}
      thumbProps={{
        id: 'preseed-cheque-thumb',
        'data-testid': 'preseed-cheque-thumb',
        'aria-labelledby': 'preseed-cheque-label',
        'aria-describedby': 'preseed-amount-hint preseed-cheque-disclaimer',
        'aria-valuetext': `${selectedLabel} (${fullAmount})`,
      }}/>
    <div className="preseed-cheque-stops" role="group" aria-label={copy('chequeOptions')}>
      {CHEQUE_SIZES.map((size, index) => <button type="button" key={size.amount}
        className={index === selectedIndex ? 'is-selected' : ''}
        data-testid={`preseed-cheque-stop-${size.amount}`} aria-pressed={index === selectedIndex}
        aria-label={t('preSeed.selectCheque', {amount: labelFor(size)})}
        onClick={() => onChange(index)}>
        <span className="preseed-cheque-tick" aria-hidden="true"/>
        <span>₹{size.display}</span><span>{copy(`${size.unit}Unit`)}</span>
      </button>)}
    </div>
    <p id="preseed-amount-hint" className="preseed-amount-hint" data-testid="preseed-amount-hint">{copy('amountHint')}</p>
    <p id="preseed-cheque-disclaimer" className="preseed-cheque-disclaimer" data-testid="preseed-cheque-disclaimer">{copy('chequeDisclaimer')}</p>
  </div>;
};